module.exports = __webpack_public_path__ + "media/151.e39e6e4c.mp3";